import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'

import { developerRootRoute } from '@/tenant/developer/root'

import { SearchSchema, listApiKeys } from './routeUtils'

const validateSearch = createValidateSearch(SearchSchema)

export const apiKeyRoute = createRoute({
    getParentRoute: () => developerRootRoute,
    path: '/apiKeys',
    component: lazyRouteComponent(() => import('./ApiKeys'), 'ApiKeys'),
    validateSearch,
    loaderDeps: ({ search }) => search,
    loader: ({ deps, abortController }) => listApiKeys(deps, 0, abortController),
})
